import React, { Component } from 'react';
import { Select, message } from 'antd';
import AjaxRequest from '../../../common/AjaxRequest';

let timeout;

class SearchInput extends Component {
    fetch = (value) => {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        
        timeout = setTimeout(() => {
            const { url, keyword, saveData } = this.props;
            const options = {
                url,
                data: { [keyword]: value },
                dataType: 'json',
                doneResult: (res => {
                    if (!res.error) {
                        saveData(res.data || res.datas);
                    } else {
                        message.error(res.error);
                    }
                }),
            };
            AjaxRequest.sendRequest(options);
        }, 300);
    }

    handleFocus = () => {
        this.handleChange('');
    }

    handleChange = (value) => {
        const { saveValue } = this.props;
        saveValue(value);

        this.fetch(value);
    }

    render() {
        const { options, style, value } = this.props;
        return (
          <Select
            mode="combobox"
            style={style}
            value={value}
            allowClear={true}
            placeholder='请输入'
            onFocus={this.handleFocus}
            onChange={this.handleChange}
          >
            {options}
          </Select>
        );
    }
}

export default SearchInput;


// WEBPACK FOOTER //
// ./src/components/invStartUp/heredity/SearchInput.js